import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

export default function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navLinks = [
    { name: 'Home', path: '/' },
    { name: 'About', path: '/about' },
    { name: 'Products', path: '/products' },
    { name: 'Contact', path: '/contact' },
  ];

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled ? 'bg-deep-black shadow-lg' : 'bg-deep-black/30 backdrop-blur-sm'
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="flex items-center justify-between h-20">
          {/* Logo */}
          <Link to="/" className="flex items-center gap-3 group">
            <img 
              src="https://static.readdy.ai/image/4f6582e073a5efa66fcf915170e338fb/884dfa3b03bef19a046381f60df37b46.jpeg" 
              alt="High Standards Smoke Shop Logo" 
              className="h-12 w-12 object-contain rounded-lg"
            />
            <span className="font-serif text-2xl text-copper tracking-wide group-hover:text-copper/80 transition-colors duration-200">
              High Standards
            </span>
          </Link>

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center gap-10">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                className={`relative text-sm font-medium tracking-wide transition-colors duration-200 ${
                  location.pathname === link.path
                    ? 'text-copper'
                    : 'text-white hover:text-copper'
                }`}
              >
                {link.name}
                {location.pathname === link.path && (
                  <span className="absolute -bottom-1 left-0 right-0 h-0.5 bg-copper"></span>
                )}
              </Link>
            ))}
          </div>

          {/* CTA Button */}
          <a
            href="https://www.google.com/maps/place/1321+S+Bay+St,+Eustis,+FL+32726"
            target="_blank"
            rel="noopener noreferrer"
            className="hidden md:block px-6 py-2.5 bg-copper text-deep-black font-medium text-sm rounded-full hover:bg-copper/90 transition-all duration-200 hover:shadow-lg hover:shadow-copper/20 whitespace-nowrap cursor-pointer"
          >
            Visit Store
          </a>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className="md:hidden text-white p-2 cursor-pointer"
            aria-label="Toggle menu"
          >
            <i className={`ri-${isMobileMenuOpen ? 'close' : 'menu'}-line text-2xl`}></i>
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      {isMobileMenuOpen && (
        <div className="md:hidden bg-forest-green border-t border-copper/20">
          <div className="px-6 py-4 space-y-4">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                onClick={() => setIsMobileMenuOpen(false)}
                className={`block py-2 text-base font-medium transition-colors duration-200 ${
                  location.pathname === link.path
                    ? 'text-copper'
                    : 'text-white hover:text-copper'
                }`}
              >
                {link.name}
              </Link>
            ))}
            <a
              href="https://www.google.com/maps/place/1321+S+Bay+St,+Eustis,+FL+32726"
              target="_blank"
              rel="noopener noreferrer"
              className="block w-full px-6 py-3 bg-copper text-deep-black font-medium text-sm rounded-full text-center hover:bg-copper/90 transition-colors duration-200 whitespace-nowrap cursor-pointer"
            >
              Visit Store
            </a>
          </div>
        </div>
      )}
    </nav>
  );
}
